import { useState, useEffect } from "react";
import FormTextBox from "../../micro_components/FormTextBox";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
  Checkbox,
  ListItemText,
  Input,
} from "@mui/material";
export default function BookDetails({
  book,
  setBook,
  handleInputChange,
  loading,
}) {
  const [bookLanguages, setBookLanguages] = useState([]);
  const [selectedCommentary, setSelectedCommentary] = useState(
    book.commentary || ""
  );
  const [selectedScore, setSelectedScore] = useState(book.score || "");

  const languages = [
    "English",
    "Spanish",
    "Chinese",
    "French",
    "German",
    "Portuguese",
    "Bosnian",
    "Dutch",
    "Japanese",
    "Persian",
    "Arabic",
    "NA",
  ];

  const commentaryAndScoreType = ["Video", "Audio", "NA"];
  const stackedMenuProps = {
    MenuListProps: {
      style: {
        display: "flex",
        flexDirection: "column",
      },
    },
  };

  useEffect(() => {
    setBookLanguages(
      book?.language && book.language !== "" ? book.language.split(", ") : []
    );

    setSelectedCommentary(book.commentary);
    setSelectedScore(book.score);
  }, [book]);

  const handleLanguageInputChange = (event) => {
    const { value } = event.target;
    setBook((prevBook) => ({
      ...prevBook,
      language: value.join(", "),
    }));
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div>
      <h3>Details</h3>
      <div className="add-book-form__field">
        {/* <FormTextBox
          value={book.language}
          label="Language"
          initialValue={""}
          name="language"
          onChange={handleInputChange}
        /> */}

        {/* LANGUAGES */}
        <Box sx={{ minWidth: 120 }}>
          <FormControl>
            <InputLabel id="language-select-label">Language</InputLabel>
            <Select
              labelId="language-select-label"
              id="language-select"
              multiple
              value={bookLanguages}
              label="Language"
              name="language"
              onChange={handleLanguageInputChange}
              variant="standard"
              style={{ width: "300px" }}
              input={<Input />}
              renderValue={(selected) => selected.join(", ")}
            >
              {languages.map((language) => (
                <MenuItem key={language} value={language}>
                  <Checkbox
                    checked={book?.language?.split(", ").includes(language)}
                  />
                  <ListItemText primary={language} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      </div>
      <div className="add-book-form__field">
        {/* COMMENTARY */}
        <Box sx={{ minWidth: 120 }}>
          <FormControl>
            <InputLabel id="commentary-select-label">Commentary</InputLabel>
            <Select
              variant="standard"
              labelId="commentary-select-label"
              id="commentary-select"
              defaultValue={selectedCommentary}
              value={selectedCommentary}
              label="Commentary"
              name="commentary"
              onChange={handleInputChange}
              style={{ width: "300px" }}
              MenuProps={stackedMenuProps}
            >
              {commentaryAndScoreType.map((type) => (
                <MenuItem
                  key={type}
                  value={type}
                  style={{ display: "flex", width: "100%" }}
                >
                  <ListItemText primary={type} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
        {/* <FormTextBox
          value={book.commentary}
          label="Commentary"
          initialValue={""}
          onChange={handleInputChange}
          name="commentary"
        /> */}
      </div>
      <div className="add-book-form__field">
        {/* SCORE */}
        <Box sx={{ minWidth: 120 }}>
          <FormControl>
            <InputLabel id="score-select-label">Score</InputLabel>
            <Select
              variant="standard"
              labelId="score-select-label"
              id="score-select"
              defaultValue={selectedScore}
              value={selectedScore}
              label="Score"
              name="score"
              onChange={handleInputChange}
              style={{ width: "300px" }}
              MenuProps={stackedMenuProps}
            >
              {commentaryAndScoreType.map((type) => (
                <MenuItem
                  key={type}
                  value={type}
                  style={{ display: "flex", width: "100%" }}
                >
                  <ListItemText primary={type} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>

        {/* <FormTextBox
          value={book.score}
          label="Score"
          initialValue={""}
          onChange={handleInputChange}
          name="score"
        /> */}
      </div>
      <div className="add-book-form__field">
        <FormTextBox
          value={book.difficulty}
          label="Difficulty"
          initialValue={""}
          onChange={handleInputChange}
          name="difficulty"
        />
      </div>
      {/* added by cameron */}
      <div className="add-book-form__field">
        <FormTextBox
          value={book.third_party_PDF_store}
          label="Third party PDF Link"
          initialValue={""}
          onChange={handleInputChange}
          name="third_party_PDF_store"
        />
      </div>
      <div className="add-book-form__field">
        <FormTextBox
          value={book.dpi_PDF_link}
          label="Dpi PDF Link"
          initialValue={""}
          onChange={handleInputChange}
          name="dpi_PDF_link"
        />
      </div>
      <div className="add-book-form__field">
        <FormTextBox
          value={book.pdf_coupon}
          label="PDF member coupon"
          initialValue={""}
          onChange={handleInputChange}
          name="pdf_coupon"
        />
      </div>
    </div>
  );
}
